module.exports = __webpack_public_path__ + "img/19-P4B.8a214ca.png";